// extracted by mini-css-extract-plugin
export default {"map-item":"MapItem_map-item__njMJk","option":"MapItem_option__ExkV6","dots":"MapItem_dots__Ex2i1","value":"MapItem_value__4-37M"};